import { uint16, uint16BE, uint32, uint8 } from '../../utils';

interface ColorFmtDict {
  [fmt: string]: (
    rgbaData: number[][],
    width: number,
    height: number
  ) => Promise<Buffer>;
}

const colorFmtDict: ColorFmtDict = {
  argb8888: (data) => Promise.resolve(generateARGB8888(data)),
  xrgb8888: (data) => Promise.resolve(generateXRGB8888(data)),
  xrgb8888_a: (data) => Promise.resolve(generateXRGB8888_a(data)),
  rgb565: (data) => Promise.resolve(generateRGB565(data)),
  rgb565_a: (data) => Promise.resolve(generateRGB565_a(data)),
  rgb565swap: (data) => Promise.resolve(generateRGB565SWAP(data)),
  rgb565swap_a: (data) => Promise.resolve(generateRGB565SWAP_a(data)),
  axrgb88565: (data) => Promise.resolve(generateAXRGB88565(data)),
  argb8565: (data) => Promise.resolve(generateARGB8565(data)),
  alpha8: (data) => Promise.resolve(generateAlpha(data)),
  // indexed8: generateIndexed8,
  argb4444: (data) => Promise.resolve(generateARGB4444(data))
};

export const getColorFmtDict = (format: string) => colorFmtDict[format];

function generateAlpha(rgbaData: number[][]) {
  const alphaBinary: Buffer[] = [];
  rgbaData.forEach((item) => {
    const alpha = item[3];
    alphaBinary.push(uint8(alpha));
  });
  return Buffer.concat(alphaBinary);
}

function generateARGB8888(rgbaData: number[][]) {
  const imgBinary: Buffer[] = [];
  rgbaData.forEach((item) => {
    // 左移动24位时前导1被认作负号 >>>0当作无符号数处理
    const argbInt =
      ((item[3] << 24) >>> 0) + (item[0] << 16) + (item[1] << 8) + item[2];
    imgBinary.push(uint32(argbInt));
  });
  return Buffer.concat(imgBinary);
}

function generateXRGB8888(rgbaData: number[][]) {
  const imgBinary: Buffer[] = [];
  rgbaData.forEach((item) => {
    const xrgbInt = (item[0] << 16) + (item[1] << 8) + item[2];
    imgBinary.push(uint32(xrgbInt));
  });
  return Buffer.concat(imgBinary);
}

function generateXRGB8888_a(rgbaData: number[][]) {
  const imgBinary = generateXRGB8888(rgbaData);
  const alphaBinary = generateAlpha(rgbaData);
  return Buffer.concat([imgBinary, alphaBinary]);
}

function generateRGB565(rgbaData: number[][]) {
  const imgBinary: Buffer[] = [];
  rgbaData.forEach((item) => {
    // 先右移截取高位，再左移组合
    const rgbInt =
      ((item[0] >> 3) << 11) + ((item[1] >> 2) << 5) + (item[2] >> 3);
    imgBinary.push(uint16(rgbInt));
  });
  return Buffer.concat(imgBinary);
}

function generateRGB565SWAP(rgbaData: number[][]) {
  const imgBinary: Buffer[] = [];
  rgbaData.forEach((item) => {
    // 先右移截取高位，再左移组合
    const rgbInt =
      ((item[0] >> 3) << 11) + ((item[1] >> 2) << 5) + (item[2] >> 3);
    imgBinary.push(uint16BE(rgbInt));
  });
  return Buffer.concat(imgBinary);
}

function generateRGB565_a(rgbaData: number[][]) {
  const imgBinary = generateRGB565(rgbaData);
  const alphaBinary = generateAlpha(rgbaData);
  return Buffer.concat([imgBinary, alphaBinary]);
}

function generateRGB565SWAP_a(rgbaData: number[][]) {
  const imgBinary = generateRGB565SWAP(rgbaData);
  const alphaBinary = generateAlpha(rgbaData);
  return Buffer.concat([imgBinary, alphaBinary]);
}

function generateAXRGB88565(rgbaData: number[][]) {
  const imgBinary: Buffer[] = [];
  rgbaData.forEach((item) => {
    // 先右移截取高位，再左移组合
    const rgbInt =
      ((item[3] << 24) >>> 0) +
      (0 << 16) +
      ((item[0] >> 3) << 11) +
      ((item[1] >> 2) << 5) +
      (item[2] >> 3);
    imgBinary.push(uint32(rgbInt));
  });
  return Buffer.concat(imgBinary);
}

function generateARGB8565(rgbaData: number[][]) {
  const imgBinary: Buffer[] = [];
  rgbaData.forEach((item) => {
    const rgbInt =
      ((item[0] >> 3) << 11) + ((item[1] >> 2) << 5) + (item[2] >> 3);
    imgBinary.push(uint16(rgbInt), uint8(item[3]));
  });
  return Buffer.concat(imgBinary);
}

function generateARGB4444(rgbaData: number[][]) {
  const imgBinary: Buffer[] = [];
  rgbaData.forEach((item) => {
    const argbInt =
      ((item[3] >> 4) << 12) +
      ((item[0] >> 4) << 8) +
      ((item[1] >> 4) << 4) +
      (item[2] >> 4);
    imgBinary.push(uint16(argbInt));
  });
  return Buffer.concat(imgBinary);
}
